<template>
  <div>
    <members-icon class="me-2" :members-count="pointDetails.memberCount" />
    <div class="description">
      {{ displayDescription }}
    </div>
  </div>
</template>

<script>
import MembersIcon from '../members-icon'
import truncate from 'lodash/truncate'

export default {
  components: { MembersIcon },

  props: {
    pointDetails: {
      type: Object,
      required: true
    }
  },

  computed: {
    displayDescription() {
      return truncate(this.pointDetails.description, {length: 150})
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  word-break: break-word;
}
</style>
